import { useMutation } from "@tanstack/react-query";
import { ContactPreferences } from "@seneca/notifications-service-types";

import { getClient } from "../../../../services";

export function useUpdatePreferences(encryptedContactKey: string) {
  return useMutation(updatePreferences(encryptedContactKey));
}

const updatePreferences =
  (encryptedContactKey: string) =>
  async (contactPreferences: Partial<ContactPreferences>) => {
    await getClient("notificationsService").savePreferencesAnonymous({
      encryptedContactKey,
      contactPreferences
    });
  };
